import styled from "styled-components";

const PlatformPhoto = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${(props) => props.border && "40px"};
  width: ${(props) => props.border && "40px"};
  border: ${(props) => (props.border ? "1px solid #e2e2ea" : "")};
  border-radius: ${(props) => (props.border ? "50%" : "")};

  #photoInput {
    display: none;
  }

  .platformImg {
    height: 20px;
    width: 20px;
  }

  @media screen and (max-width: 768px) {
    .platformImg {
      // height: 12px;
      // width: 12px;
      left: 18px;

      .icon {
        height: 16px;
      }
    }
  }
`;

export default PlatformPhoto;
